'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';
import classes from './FavoritesBubbles.module.css';
import axios from 'axios';
import { useAuthContext } from '@/context';

const FavoritesBubbles = ({ listing }) => {
	const [favorites, setFavorites] = useState();

	const { auth } = useAuthContext();

	const [loading, setLoading] = useState(true);

	const fetchFavorites = async () => {
		await axios
			.get(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/users/favorites/all/${listing._id}`
			)
			.then((res) => setFavorites(res.data))
			.catch((err) => {
				console.log(err);
			});
		setLoading(false);
	};

	useEffect(() => {
		const isBot = /bot|crawl|slurp|spider|Prerender|facebookexternalhit/i.test(
			navigator?.userAgent
		);

		if (!isBot) {
			fetchFavorites();
		}
	}, [listing]);

	return (
		<>
			{loading ? (
				<section className={classes.rowGap}>
					<section className={classes.imageSection}>
						{[1, 2, 3].map((fav, idx) => (
							<div
								className={classes.favoriteImgPlaceHolder}
								key={idx * 12345}
							/>
						))}
					</section>
				</section>
			) : (
				favorites &&
				favorites.length > 0 && (
					<section className={classes.rowGap}>
						<section className={classes.imageSection}>
							{favorites.map((fav, idx) => (
								<Image
									key={idx}
									width={50}
									height={50}
									src={fav.picture}
									alt={fav.firstName}
									className={classes.favoriteImg}
									referrerPolicy="no-referrer"
								/>
							))}
						</section>
						{favorites &&
						favorites?.length > 0 &&
						auth.user &&
						favorites.find((fav) => fav._id === auth.user?._id) ? (
							<h6 className={classes.presentInCartsBody}>
								<b className={classes.colorText}>You </b>
								{favorites.length === 1
									? ' like this'
									: ` and ${
											favorites.length > 2 ? `${favorites.length - 1}` : ''
									  } others like this`}{' '}
							</h6>
						) : (
							<h6 className={classes.presentInCarts}>
								{favorites.length === 1
									? `${favorites[0].firstName} likes this`
									: `${favorites[0].firstName} and ${
											favorites.length > 2 ? `${favorites.length - 1}` : ''
									  } others like this`}
							</h6>
						)}
					</section>
				)
			)}
		</>
	);
};

export default FavoritesBubbles;
